
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb966"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb966"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("baa6D", function(module, exports) {

$parcel$export(module.exports, "getUser", () => $820877bea407f5fe$export$7cbf767827cd68ba);
$parcel$export(module.exports, "isDefaultUser", () => $820877bea407f5fe$export$341b57a6d6726bae);
$parcel$export(module.exports, "setCookie", () => $820877bea407f5fe$export$110700823644f4a6);
$parcel$export(module.exports, "removeCookie", () => $820877bea407f5fe$export$6a874b7a74007875);
$parcel$export(module.exports, "showDataAlerts", () => $820877bea407f5fe$export$a142c19495d0d5e0);
$parcel$export(module.exports, "initInfoButtons", () => $820877bea407f5fe$export$4ba72900f5c75680);
$parcel$export(module.exports, "showWelcomeModal", () => $820877bea407f5fe$export$c5f19ed6b35c3898);

var $cX88K = parcelRequire("cX88K");
function $820877bea407f5fe$var$getCookie(cName) {
    let name = cName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
}
function $820877bea407f5fe$export$7cbf767827cd68ba() {
    let user = $820877bea407f5fe$var$getCookie("id");
    if (user === undefined) {
        console.log("Defaulting user as no cookie set");
        return "1234";
    } else return user;
}
function $820877bea407f5fe$export$341b57a6d6726bae() {
    return $820877bea407f5fe$export$7cbf767827cd68ba() == "1234";
}
function $820877bea407f5fe$var$isNewToSite() {
    return !localStorage.getItem("visited") && $820877bea407f5fe$export$341b57a6d6726bae();
}
async function $820877bea407f5fe$export$110700823644f4a6(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
async function $820877bea407f5fe$export$6a874b7a74007875(cname) {
    $820877bea407f5fe$export$110700823644f4a6(cname, "", -100);
}
async function $820877bea407f5fe$export$a142c19495d0d5e0(showRecencyAlert = true) {
    if ($820877bea407f5fe$export$341b57a6d6726bae()) document.getElementById("sampleDataWarning").innerHTML = "<div class='alert alert-warning'><strong>Displaying sample data!</strong> Please login via the <a href='/account.html'>Account page</a> to see your own data.</div>";
    else if (showRecencyAlert && $820877bea407f5fe$var$getCookie("recencyDismiss") != "true") (0, $cX88K.getUserSettings)(function(res) {
        if (res.shotRecency > 1) {
            document.getElementById("sampleDataWarning").innerHTML = `<div class='alert alert-info alert-dismissible'><a id="recencyAlertDismiss" href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a><strong>Showing stats for the last ${res.shotRecency} shots. </strong> To change your shot recency, visit the <a href='/account.html'>Account page</a>.</div>`;
            document.getElementById("recencyAlertDismiss").addEventListener("click", function(event) {
                $820877bea407f5fe$export$110700823644f4a6("recencyDismiss", "true", 7);
            });
        }
    });
}
async function $820877bea407f5fe$export$4ba72900f5c75680() {
    //Have to do this because .popover() throws an expcetion in bootstrap
    $(".info-popover").each(function(index, value) {
        try {
            $(this).popover("click");
        } catch (err) {
        //Do nothing
        }
    });
}
async function $820877bea407f5fe$export$c5f19ed6b35c3898() {
    if ($820877bea407f5fe$var$isNewToSite()) $.get("components/welcomeModal.html", function(welcomeModalHtml) {
        let bodyHtml = document.getElementsByTagName("body")[0];
        bodyHtml.innerHTML = bodyHtml.innerHTML + welcomeModalHtml;
        $("#welcomeModal").modal("show");
        (0, $cX88K.getGlobalShotsCount)((res)=>{
            let remainder = res % 100;
            let shotsCount = (res - remainder).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "+";
            document.getElementById("shotCount").innerHTML = shotsCount;
        });
        $("#letsGoBtn, .close").on("click", function(e) {
            localStorage.setItem("visited", "true");
        });
    });
}

});
parcelRegister("cX88K", function(module, exports) {

$parcel$export(module.exports, "getClubsWithStats", () => $96e14f2a7c3555e4$export$c65ad084a4ea6d4d);
$parcel$export(module.exports, "getSessionComapare", () => $96e14f2a7c3555e4$export$20b93455458f7c07);
$parcel$export(module.exports, "getSessionsLeaderboard", () => $96e14f2a7c3555e4$export$43c35b98102ad838);
$parcel$export(module.exports, "getGlobalShotsCount", () => $96e14f2a7c3555e4$export$25f12221396eaa3);
$parcel$export(module.exports, "setUserRecency", () => $96e14f2a7c3555e4$export$1ada1508b59f1165);
$parcel$export(module.exports, "emailOptOut", () => $96e14f2a7c3555e4$export$189daa66f73b5356);
$parcel$export(module.exports, "setMarketingEmailSetting", () => $96e14f2a7c3555e4$export$85dcb9b46c44fd5b);
$parcel$export(module.exports, "setUserUnitPreference", () => $96e14f2a7c3555e4$export$d81fe47effd19f97);
$parcel$export(module.exports, "getUserSettings", () => $96e14f2a7c3555e4$export$bdf060f8502bcfbd);
$parcel$export(module.exports, "pullClubs", () => $96e14f2a7c3555e4$export$cdda555d34ce06ea);
$parcel$export(module.exports, "pullShots", () => $96e14f2a7c3555e4$export$32774dfb37d74902);
$parcel$export(module.exports, "topTracerLogin", () => $96e14f2a7c3555e4$export$695a80f71377924a);

var $baa6D = parcelRequire("baa6D");
async function $96e14f2a7c3555e4$export$2205b0c552d8ef4d(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/clubs`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response); // JSON response  
        else if (this.status == 401) {
            (0, $baa6D.removeCookie)("id");
            location.reload();
        }
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$c65ad084a4ea6d4d(ordering, fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/clubsWithStats`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) {
            var output = this.response.clubsWithStats;
            if (ordering == 2) output.sort(function(first, second) {
                return second.stats.averageGoodDistance - first.stats.averageGoodDistance;
            });
            else if (ordering == 3) output.sort(function(first, second) {
                return second.stats.successRate - first.stats.successRate;
            });
            else if (ordering == 4) output.sort(function(first, second) {
                return second.stats.rightOfflineBias - first.stats.rightOfflineBias;
            });
            else if (ordering == 5) output.sort(function(first, second) {
                return second.stats.leftOfflineBias - first.stats.leftOfflineBias;
            });
            else output.sort(function(first, second) {
                return first.club.displayOrder - second.club.displayOrder;
            });
            fn({
                clubsWithStats: output,
                units: this.response.units
            }); // JSON response  
        } else if (this.status == 401) {
            (0, $baa6D.removeCookie)("id");
            location.reload();
        }
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$20b93455458f7c07(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/sessionCompare`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response.sessions); // JSON response  
        else if (this.status == 401) {
            (0, $baa6D.removeCookie)("id");
            location.reload();
        }
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$43c35b98102ad838(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/sessionsLeaderboard`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response); // JSON response  
        else if (this.status == 401) {
            (0, $baa6D.removeCookie)("id");
            location.reload();
        }
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$25f12221396eaa3(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/howmany/shots`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response); // JSON response  
        else if (this.status == 401) {
            (0, $baa6D.removeCookie)("id");
            location.reload();
        }
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$1ada1508b59f1165(recency, fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("PUT", `https://api.my-golf-insights.com/shot-recency/${recency}`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(null);
        else fn(this.response);
    };
    xmlHttp.onerror = function(e) {
        fn("Failed to update shot recency");
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$189daa66f73b5356(email, success, failure) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("PUT", `https://api.my-golf-insights.com/opt-out-emails/${email}`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 204) success();
        else failure();
    };
    xmlHttp.onerror = function(e) {
        failure();
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$85dcb9b46c44fd5b(isOptIn, success, failure) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("PUT", `https://api.my-golf-insights.com/user/marketing-emails/${isOptIn}`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 204) success();
        else failure();
    };
    xmlHttp.onerror = function(e) {
        failure();
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$d81fe47effd19f97(unitPreference, fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("PUT", `https://api.my-golf-insights.com/user/unit-preference/${unitPreference}`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(null);
        else fn(this.response);
    };
    xmlHttp.onerror = function(e) {
        fn("Failed to update unit preference");
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$bdf060f8502bcfbd(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/user/settings`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response);
        else if (this.status == 401) {
            (0, $baa6D.removeCookie)("id");
            location.reload();
        }
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$cdda555d34ce06ea(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/top-tracer-clubs`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response); // JSON response  
        else fn(null, this.status == 401 || (0, $baa6D.isDefaultUser)());
    };
    xmlHttp.onerror = function(e) {
        fn(null, (0, $baa6D.isDefaultUser)());
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$32774dfb37d74902(fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    xmlHttp.open("GET", `https://api.my-golf-insights.com/top-tracer-shots`);
    xmlHttp.setRequestHeader("Authorization", "Bearer " + (0, $baa6D.getUser)());
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response); // JSON response  
        else fn(null, this.status == 401 || (0, $baa6D.isDefaultUser)());
    };
    xmlHttp.onerror = function(e) {
        fn(null, (0, $baa6D.isDefaultUser)());
    };
    xmlHttp.send(null);
}
async function $96e14f2a7c3555e4$export$695a80f71377924a(username, password, marketingValue, fn) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.responseType = "json";
    // xmlHttp.setRequestHeader('Content-type', 'application/json'); 
    xmlHttp.open("POST", `https://api.my-golf-insights.com/top-tracer-login`);
    xmlHttp.onload = function(e) {
        if (this.status == 200) fn(this.response); // JSON response  
        else fn(null);
    };
    xmlHttp.onerror = function(e) {
        fn(null);
    };
    xmlHttp.send(`{"loginRequestBody": {"email":"${username}","password":"${password}"},"marketingEmails":${marketingValue}}`);
}

});



parcelRequire("baa6D");

//# sourceMappingURL=index.b1dc7cd6.js.map
